<template>
  <div>
    <model-table
      :collection="tipShareRules"
      :orderable="true"
      order-field="priorityOrder"
      display-order-title="Set Priority Order"
      display-order-description="Only the first valid tip share rule will apply on any paid tip. Drag higher priority tip share rules to the top."
      :columns="[
        { field: 'id' },
        { field: 'name' },
        { name: 'source', field: tipShareRule => $_.startCase(tipShareRule.tipOutSource), component: 'chip' },
        { name: 'percentage', field: (tipShareRule) => tipShareRule.tipOutPercentageThousandths / 1000, component: 'percent-2' },
        { name: 'conditions', field: (tipShareRule) => $_.map($mh.objectToArray(tipShareRule.conditions), condition => $_.startCase(condition)), component: 'chips', limitValues: 4 },
        { name: 'library', component: 'library-link', hide: currentCircuit.isLibrary },
        { name: 'actions', label: 'Action', align: 'right' }
      ]"
      :has-library="!currentCircuit.isLibrary"
      :library-collection="tipShareRuleLibrary"
      :library-columns="[
        { field: 'id' },
        { field: 'name' },
        { name: 'source', field: tipShareRule => $_.startCase(tipShareRule.tipOutSource), component: 'chip' },
        { name: 'percentage', field: (tipShareRule) => tipShareRule.tipOutPercentageThousandths / 1000, component: 'percent-2' }
      ]"
      :link-filter="libraryFilterFunction"
    >
      <tip-share-rule-form />

      <template #set-order-button-label>
        Set Priority
      </template>
    </model-table>
  </div>
</template>

<script>
import ModelTable from 'src/modules/admin/components/ModelTable'
import TipShareRuleForm from 'src/modules/admin/tip/TipShareRuleForm'

export default {
  name: 'TipShareRuleTable',
  components: {
    ModelTable,
    TipShareRuleForm
  },
  configuration: ['currentCircuit'],
  models: {
    tipShareRules: {
      tipPoolShares: {
        tipPoolType: {
          fields: ['id', 'name']
        }
      },
      libraryParentId: true,
      receiveLibraryUpdates: true
    },
    tipShareRuleLibrary: {
      libraryChildSiteIds: true,
      variables () {
        return {
          searchString: this.libraryFilterString,
          limit: 10
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      libraryFilterString: null
    }
  },
  methods: {
    libraryFilterFunction (value) {
      this.libraryFilterString = !_.isEmpty(value) ? value.trim() : null
    }
  }
}
</script>
